import glam from 'glamorous';
import React from 'react';
import { createPureComponent } from 'module/Common';

const Wrapper = glam.div({});

type Props = {
  content: string;
};

export const RichText = createPureComponent<Props>('RichText', props => (
  <Wrapper
    dangerouslySetInnerHTML={{
      __html: props.content,
    }}
  />
));



// WEBPACK FOOTER //
// ./src/module/View/Common/component/RichText/index.tsx